import {
  booleanAttribute,
  Component,
  computed,
  ElementRef,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RvButtonComponent } from 'src/app/components/button/button.component';

/** The disclaimer a company accepts to connect. Starts unchecked on every render. */
@Component({
  selector: 'cap-alerts-disclaimer',
  templateUrl: './cap-alerts-disclaimer.component.html',
  styleUrl: './cap-alerts-disclaimer.component.scss',
  imports: [MatCheckboxModule, RvButtonComponent],
})
export class CapAlertsDisclaimerComponent {
  /** The user cannot accept: no edit rights, or the plan lapsed. */
  readonly disabled = input(false, { transform: booleanAttribute });
  /** Accepting is in flight. */
  readonly busy = input(false, { transform: booleanAttribute });

  readonly accepted = output<void>();
  readonly cancelled = output<void>();

  private readonly heading = viewChild<ElementRef<HTMLElement>>('heading');

  protected readonly termsAccepted = signal(false);

  protected readonly canAccept = computed(
    () => this.termsAccepted() && !this.disabled() && !this.busy(),
  );

  /** Moves focus to the heading, so a screen reader announces the view that just replaced the previous one. */
  focusHeading(): void {
    this.heading()?.nativeElement.focus();
  }

  protected accept(): void {
    if (this.canAccept()) {
      this.accepted.emit();
    }
  }
}
